<template>
  <router-view />
</template>
<script setup>
import { formContextKey } from "element-plus";
import {ref, watch } from "vue";
import { useRoute,useRouter  } from "vue-router";
import store from "./store";
const route= useRoute()
const router = useRouter();


const whitePath = ['/login', '/index', '/']

watch(route, (to) => {
  if (to.path.startsWith('/webpage')) {
    return
  }
  if (whitePath.indexOf(to.path) === -1) {
    store.commit('ADD_TABS', { name: to.name, path: to.path })
  } else if (!to.name && to.path.startsWith('/admin')) {
    router.push('/admin/index')
  }
}, { deep: true, immediate: true })
</script>

<style>

html,
body,
#app {
  height: 100%;
}

.app-container {
  padding: 20px;
}
</style>
<!-- 用于全局定义 -->
